"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Clock;
var React = _interopRequireWildcard(require("react"));
var _internal = require("@aws-amplify/ui-react/internal");
var _uiReact = require("@aws-amplify/ui-react");
var _excluded = ["overrides"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function Clock(props) {
  var overridesProp = props.overrides,
    rest = _objectWithoutProperties(props, _excluded);
  var variants = [{
    overrides: {
      Clock: {}
    },
    variantValues: {
      variation: "success"
    }
  }, {
    overrides: {
      Clock: {
        paths: [{
          d: "M13.0985 10.6338L11.0003 9.42286L11.0003 5C11.0003 4.44771 10.5526 4 10.0003 4C9.44802 4 9.00031 4.44771 9.00031 5L9.00031 10C9.00021 10.3573 9.19083 10.6876 9.50031 10.8662L12.0985 12.3662C12.5768 12.6424 13.1885 12.4784 13.4647 12C13.7408 11.5216 13.5769 10.9099 13.0985 10.6338ZM10 0C4.47716 0 0 4.47716 0 10C0 15.5228 4.47716 20 10 20C15.5228 20 20 15.5228 20 10C19.9939 4.4797 15.5203 0.00614444 10 0ZM9.9999 18C5.58162 18 1.9999 14.4183 1.9999 10C1.9999 5.58173 5.58162 2.00001 9.9999 2.00001C14.4182 2.00001 17.9999 5.58173 17.9999 10C17.9948 14.4162 14.4161 17.995 9.9999 18Z",
          fill: "rgba(250,195,15,1)",
          fillRule: "evenodd",
          style: {
            transform: "translate(8.33%, 8.33%)"
          }
        }]
      }
    },
    variantValues: {
      variation: "warning"
    }
  }, {
    overrides: {
      Clock: {
        paths: [{
          d: "M13.0985 10.6338L11.0003 9.42286L11.0003 5C11.0003 4.44771 10.5526 4 10.0003 4C9.44802 4 9.00031 4.44771 9.00031 5L9.00031 10C9.00021 10.3573 9.19083 10.6876 9.50031 10.8662L12.0985 12.3662C12.5768 12.6424 13.1885 12.4784 13.4647 12C13.7408 11.5216 13.5769 10.9099 13.0985 10.6338ZM10 0C4.47716 0 0 4.47716 0 10C0 15.5228 4.47716 20 10 20C15.5228 20 20 15.5228 20 10C19.9939 4.4797 15.5203 0.00614444 10 0ZM9.9999 18C5.58162 18 1.9999 14.4183 1.9999 10C1.9999 5.58173 5.58162 2.00001 9.9999 2.00001C14.4182 2.00001 17.9999 5.58173 17.9999 10C17.9948 14.4162 14.4161 17.995 9.9999 18Z",
          fill: "rgba(235,15,48,1)",
          fillRule: "evenodd",
          style: {
            transform: "translate(8.33%, 8.33%)"
          }
        }]
      }
    },
    variantValues: {
      variation: "error"
    }
  }, {
    overrides: {
      Clock: {
        paths: [{
          d: "M13.0985 10.6338L11.0003 9.42286L11.0003 5C11.0003 4.44771 10.5526 4 10.0003 4C9.44802 4 9.00031 4.44771 9.00031 5L9.00031 10C9.00021 10.3573 9.19083 10.6876 9.50031 10.8662L12.0985 12.3662C12.5768 12.6424 13.1885 12.4784 13.4647 12C13.7408 11.5216 13.5769 10.9099 13.0985 10.6338ZM10 0C4.47716 0 0 4.47716 0 10C0 15.5228 4.47716 20 10 20C15.5228 20 20 15.5228 20 10C19.9939 4.4797 15.5203 0.00614444 10 0ZM9.9999 18C5.58162 18 1.9999 14.4183 1.9999 10C1.9999 5.58173 5.58162 2.00001 9.9999 2.00001C14.4182 2.00001 17.9999 5.58173 17.9999 10C17.9948 14.4162 14.4161 17.995 9.9999 18Z",
          fill: "rgba(239,240,240,1)",
          fillRule: "evenodd",
          style: {
            transform: "translate(8.33%, 8.33%)"
          }
        }]
      }
    },
    variantValues: {
      variation: "disabled"
    }
  }, {
    overrides: {
      Clock: {
        paths: [{
          d: "M13.0985 10.6338L11.0003 9.42286L11.0003 5C11.0003 4.44771 10.5526 4 10.0003 4C9.44802 4 9.00031 4.44771 9.00031 5L9.00031 10C9.00021 10.3573 9.19083 10.6876 9.50031 10.8662L12.0985 12.3662C12.5768 12.6424 13.1885 12.4784 13.4647 12C13.7408 11.5216 13.5769 10.9099 13.0985 10.6338ZM10 0C4.47716 0 0 4.47716 0 10C0 15.5228 4.47716 20 10 20C15.5228 20 20 15.5228 20 10C19.9939 4.4797 15.5203 0.00614444 10 0ZM9.9999 18C5.58162 18 1.9999 14.4183 1.9999 10C1.9999 5.58173 5.58162 2.00001 9.9999 2.00001C14.4182 2.00001 17.9999 5.58173 17.9999 10C17.9948 14.4162 14.4161 17.995 9.9999 18Z",
          fill: "rgba(14,15,27,1)",
          fillRule: "evenodd",
          style: {
            transform: "translate(8.33%, 8.33%)"
          }
        }]
      }
    },
    variantValues: {
      variation: "default"
    }
  }];
  var overrides = (0, _internal.mergeVariantsAndOverrides)((0, _internal.getOverridesFromVariants)(variants, props), overridesProp || {});
  return /*#__PURE__*/React.createElement(_uiReact.Icon, _extends({
    width: "24px",
    height: "24px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    position: "relative",
    padding: "0px 0px 0px 0px",
    viewBox: {
      minX: 0,
      minY: 0,
      width: 24,
      height: 24
    },
    paths: [{
      d: "M13.0985 10.6338L11.0003 9.42286L11.0003 5C11.0003 4.44771 10.5526 4 10.0003 4C9.44802 4 9.00031 4.44771 9.00031 5L9.00031 10C9.00021 10.3573 9.19083 10.6876 9.50031 10.8662L12.0985 12.3662C12.5768 12.6424 13.1885 12.4784 13.4647 12C13.7408 11.5216 13.5769 10.9099 13.0985 10.6338ZM10 0C4.47716 0 0 4.47716 0 10C0 15.5228 4.47716 20 10 20C15.5228 20 20 15.5228 20 10C19.9939 4.4797 15.5203 0.00614444 10 0ZM9.9999 18C5.58162 18 1.9999 14.4183 1.9999 10C1.9999 5.58173 5.58162 2.00001 9.9999 2.00001C14.4182 2.00001 17.9999 5.58173 17.9999 10C17.9948 14.4162 14.4161 17.995 9.9999 18Z",
      fill: "rgba(37,131,79,1)",
      fillRule: "evenodd",
      style: {
        transform: "translate(8.33%, 8.33%)"
      }
    }]
  }, (0, _internal.getOverrideProps)(overrides, "Clock"), rest));
}